import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { useDispatch, useSelector } from 'react-redux';
import { fulfilled, clean } from 'redux-saga-thunk'

import { Modal, ModalBody } from "reactstrap"
import { useFormik } from 'formik'

import closeIcon from "../../../assets/images/modal-close-icon.svg"
import SelectInputOverlap from '../../../components/Common/SelectInputOverlap';
import { showToastMessage } from '../../../helpers/toaster'

import { viewSubject as onViewSubject } from '../../../store/subject/actions';
import { createBadge as onCreateBadge, updateBadge as onUpdateBadge } from '../../../store/badges/actions';

import _ from 'underscore'

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

library.add(fas, fab);

const CreateBadgeModal = ({ visible, subject, isEdit, badge, badges_type, onClose, onDelete, onCreate }) => {

    const dispatch = useDispatch()
    const location = useLocation()

    const [selectedBadge, setSelectedBadge] = useState({});

    const { get_create_success, get_update_success } = useSelector(state => ({
        get_create_success: fulfilled(state, "CREATE_BADGE"),
        get_update_success: fulfilled(state, "UPDATE_BADGE"),
        
    }))

    const initialValues = {
        subject_id: "",
        badge_cat_id: 1,
        badge_typ_id: "",
        description: "",
        title: ""
    }

    const onSubmit = values => {

        if(isEdit) {
            values['id'] = selectedBadge.id
            values['user_id'] = selectedBadge.user_id
            dispatch(onUpdateBadge(values))
        }
        else {
            let currentUrlParams = new URLSearchParams(location.search);
            let data = {
                user_id: currentUrlParams.get('sid'),
                ...values
            }
            dispatch(onCreateBadge(data))
        }

        
    }

    const validate = values => {

        let errors = {}
    
        if(!values.subject_id) {
          errors.subject_id = "Subject ID required!"
        }

        if(!values.badge_typ_id) {
            errors.badge_typ_id = "Type ID required!"
        }

        if(!values.description) {
            errors.description = "Description required!"
        }

        if(!values.title) {
            errors.title = "Title required!"
        }
        
        return errors
    }

    const formik = useFormik({
        initialValues,
        onSubmit,
        validate
    }) 

    const handleOnSelectSubject = (id) => {
        formik.setFieldValue("subject_id", id)
    }

    const handleOnSelectType = (id) => {
        formik.setFieldValue("badge_typ_id", id)
    }

    const handleDeleteBadge = () => {
        onDelete()
    }

    useEffect(() => {
        if(get_create_success) {
            dispatch(clean("CREATE_REWARD"))
            showToastMessage('success',"Badge created")
            onCreate()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
     }, [get_create_success])

     useEffect(() => {
        if(get_update_success && isEdit) {
            dispatch(clean("UPDATE_REWARD"))
            showToastMessage('success',"Badge updated")
            onCreate()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
     }, [get_update_success])

    useEffect(() => {
        dispatch(onViewSubject())
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(isEdit) {
            setSelectedBadge(badge)
        }
        else {
            setSelectedBadge(null)
            formik.resetForm()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEdit])

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedBadge])

    useEffect(() => {
        if(!_.isEmpty(selectedBadge)) {
            for (let key in formik.values) {
                if(Object.keys(selectedBadge).includes(key)) {
                    formik.setFieldValue(key, selectedBadge[key])
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedBadge])

  return (
    <Modal isOpen={visible} toggle={onClose} size='lg'>
        <ModalBody>
        <div className='create-badges-modal-wrapper'>
            <div className='title'>
                <img className='close-icon' src={closeIcon} alt="" onClick={onClose} />
            </div>
            <div className='desp text-start mt-5'>
                <div className='px-4 pt-4'>
                    <div className='d-flex align-items-center mb-4'>
                    <h4> { isEdit ? "Edit" : "Create" } Badges</h4>
                    { isEdit && <h4 className='ms-auto text-primary-500 pointer' onClick={handleDeleteBadge}>
                                <FontAwesomeIcon icon="fas fa-trash" />
                    </h4> }
                    </div>
                    { visible && 
                        <form className="create-badges-form" name="createRewardForm" onSubmit={formik.handleSubmit}>
                            <div className='select-reward-box'>
                                <SelectInputOverlap
                                    fieldType="name"
                                    fieldLabel="selectBadgesSubject"
                                    data={subject}  
                                    fieldId={selectedBadge?.subject_id}
                                    placeholder="Select subject"
                                    design="primary"
                                    onChange={handleOnSelectSubject}
                                />
                                { (formik.touched.subject_id && formik.errors.subject_id) && <p className="mt-1 text-sm text-red-500">{formik.errors.subject_id}</p> }
                            </div>
                            <div className='select-reward-box'>
                                <div className='input-box grey-box mb-0'>
                                    <input className='form-control' name="title" placeholder='Enter badges name' onBlur={formik.handleBlur} onChange={formik.handleChange} value={formik.values.title} />
                                </div>
                                { (formik.touched.title && formik.errors.title) && <p className="mt-1 text-sm text-red-500">{formik.errors.title}</p> }
                            </div>
                            <div className='select-reward-box'>
                                <textarea className='form-control' name="description" placeholder='Badges details' onBlur={formik.handleBlur} onChange={formik.handleChange} value={formik.values.description}></textarea>
                                { (formik.touched.description && formik.errors.description) && <p className="mt-1 text-sm text-red-500">{formik.errors.description}</p> }
                            </div>
                            <SelectInputOverlap
                                fieldType="image"
                                fieldLabel="selectBadgesImage"
                                data={badges_type} 
                                fieldId={selectedBadge?.badge_typ_id} 
                                placeholder="Select badges image"
                                design="primary"
                                type="image"
                                onChange={handleOnSelectType}
                            />
                            { (formik.touched.badge_typ_id && formik.errors.badge_typ_id) && <p className="mt-1 text-sm text-red-500">{formik.errors.badge_typ_id}</p> }
                            <div className='mt-5'>
                                <button className='btn btn-primary submit-btn'>Save</button>
                                <div className='btn link-btn link-dark-btn ms-3' onClick={onClose}>Cancel</div>
                            </div>
                        </form>
                    }
                </div>
            </div>
        </div>
        </ModalBody>
    </Modal>
  )
}


export default CreateBadgeModal